// these are the Retailers for which we support the White Glove purchase flow;
//   Cash Funds are lower margin for us, so we want to discourage conversion into GCE.
//   IN GENERAL, we want to encourage Couples to use these Retailers since we get sweet, sweet deals from them.
export const WHITE_GLOVE_RETAILER_DOMAIN_REGEX = /(amazon\.com)/i;

export const ENCOURAGED_RETAILER_INFO: {
  name: string;
  domain: string;
  logo: {
    style: Record<string, string>;
    url: string;
    urlMobile1?: string;
    urlMobile2?: string;
  };
}[] = [
  {
    name: 'Amazon',
    domain: 'amazon.com',
    logo: { style: { height: '32px', paddingTop: '2px' }, url: 'https://withjoy.com/assets/public/add-your-gift-brand-amazon.png?q' },
  },
  {
    name: 'Crate & Barrel',
    domain: 'crateandbarrel.com',
    logo: { style: { height: '22px', paddingTop: '3px' }, url: 'https://withjoy.com/assets/public/add-your-gift-brand-c-and-b.png?o' },
  },
  {
    name: 'Williams-Sonoma',
    domain: 'williams-sonoma.com',
    logo: {
      style: { height: '22px', paddingTop: '3px' },
      url: 'https://withjoy.com/assets/public/add-your-gift-brand-williams-sonoma.png?o',
      urlMobile1: 'https://withjoy.com/assets/public/add-your-gift-brand-ws-williams-.png?o',
      urlMobile2: 'https://withjoy.com/assets/public/add-your-gift-brand-ws-sonoma.png?o',
    },
  },
];
export const ENCOURAGED_RETAILER_DOMAIN_SET = new Set(ENCOURAGED_RETAILER_INFO.map(({ domain }) => domain));
